import * as React from "react";
import { FlowLayout } from "kw/components/FlowLayout";
import { Error404 } from "kw/Error404";

function Error404Page() {
  return (
    <FlowLayout steps={[]} history={[]}>
      <Error404 />
    </FlowLayout>
  );
}

export { Error404Page };
